module.exports = __webpack_public_path__ + "static/media/header_profile3167a1aa0277db965e0d90e945d27ae8.webp";